import axios from 'axios';

// 🎯 A single axios instance that automatically attaches the token to every
// call, and automatically redirects the user to the login page if the token
// expired or was rejected (401).
const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sap_bim_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('sap_bim_token');
      localStorage.removeItem('sap_bim_user');
      // We use a custom event instead of redirecting directly here, so that
      // AuthContext stays the single place in charge of the login state.
      window.dispatchEvent(new Event('sap-bim-unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
